import {XIcon} from '@primer/octicons-react'
import {Heading, IconButton} from '@primer/react'

import styles from './AgentIcebreakers.module.css'
import {getIcebreakers} from '../../constants/icebreakers'
import type {IcebreakerOption} from '../../types/icebreaker'

interface AgentIcebreakersProps {
  onSelect: (option: IcebreakerOption) => void
  onDismiss: () => void
  variant?: string
  location?: string
  /** Override the default heading text. */
  heading?: string
  /** Override the default icebreaker items. When provided, `variant` is ignored. */
  items?: IcebreakerOption[]
}

export function AgentIcebreakers({onSelect, onDismiss, variant, heading, items}: AgentIcebreakersProps) {
  const icebreakers = items ?? getIcebreakers(variant)
  return (
    <div data-testid="agent-icebreakers">
      <div className={styles.header}>
        <Heading as="h3" className={styles.headerTitle}>
          {heading ?? 'Get started with agents'}
        </Heading>
        <IconButton
          variant="invisible"
          size="small"
          aria-label="Dismiss suggestions"
          icon={XIcon}
          onClick={onDismiss}
        />
      </div>
      <div className={styles.container}>
        {icebreakers.map(icebreaker => (
          <button
            key={icebreaker.title}
            type="button"
            className={styles.icebreaker}
            onClick={() => onSelect(icebreaker)}
            data-testid={`icebreaker-${icebreaker.title.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <span className={styles.iconWrapper}>{icebreaker.icon}</span>
            <div className={styles.textContent}>
              <span className={styles.title}>{icebreaker.title}</span>
              <span className={styles.subheader}>{icebreaker.subheader}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}
